var setTaggage = function () {

	///
	/// Filtres
	///

	// On est dans la zone de filtre
	let checkboxFiltre = document.querySelectorAll('.lr--checkbox');
	if (checkboxFiltre.length > 0) {
		for (var i = 0; i < checkboxFiltre.length; i++) {
			let categorie = 'Filtre';
			let action = checkboxFiltre[i].name;
			let libelle = checkboxFiltre[i].value;
			let valeur = '';

			/// Spécificité filtre par type
			if (action === 'typecircuit') {
				libelle = checkboxFiltre[i].nextElementSibling.innerText.trim();
				action = 'type';
			}
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			checkboxFiltre[i].setAttribute('data-ga', obj);
		}
	}

	// Bouton 'Plus de filtres'
	let btnShowAllFilters = document.querySelector('[data-show="moreFiltres"]');
	if (btnShowAllFilters !== null) {
		let categorie = 'Filtre';
		let action = 'Toggle';
		let libelle = 'Afficher plus de filtres';
		let valeur = true;
		let obj = JSON.stringify({
			categorie: categorie,
			action: action,
			libelle: libelle,
			valeur: valeur
		});
		btnShowAllFilters.setAttribute('data-ga', obj);
	}

	///
	/// Affichage
	///

	// Tri
	let btnTri = document.querySelectorAll('.js-tri');
	if (btnTri.length > 0) {
		for (var i = 0; i < btnTri.length; i++) {
			let categorie = 'Filtre';
			let action = 'tri';
			let libelle = btnTri[i].nextElementSibling.innerText;
			let valeur = true;
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			btnTri[i].setAttribute('data-ga', obj);
		}
	}


	// Boutons vue par carte/liste
	let toggleMap = document.querySelector('[data-js="toggleMap"]');
	if (toggleMap !== null) {
		let categorie = 'Affichage par vue';
		let action = 'Toggle';
		let libelle = !JSON.parse(toggleMap.dataset.map) ? 'carte' : 'liste';
		let valeur = '';
		let obj = JSON.stringify({
			categorie: categorie,
			action: action,
			libelle: libelle,
			valeur: valeur
		});
		toggleMap.setAttribute('data-ga', obj);
	}

	///
	/// Circuit
	///

	let circuit = document.querySelectorAll('.circuit');
	if (circuit.length > 0) {
		for (var i = 0; i < circuit.length; i++) {
			// Click sur un circuit
			let link = circuit[i].querySelector('[data-expand-link]');
			let categorie = 'Circuit';
			let action = 'Click';
			let codeCircuit = '';
			let url = link.getAttribute('href');
			if (url != null) {
				let paths = url.split('/');
				let lastPath = paths.slice(-1).pop();
				let arr = lastPath.split('--');
				codeCircuit = arr[0];
			}
			let libelle = codeCircuit;
			let valeur = true;
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			link.setAttribute('data-ga', obj);

			// // Slide
			// let btnNext = circuit[i].querySelector('.slick-next');
			// let btnPrev = circuit[i].querySelector('.slick-prev');
			// if (btnNext != null) {
			// 	let actionSlide = 'Slide';
			// 	let valeurSlide = 1;
			// 	let objSlide = JSON.stringify({
			// 		categorie: categorie,
			// 		action: actionSlide,
			// 		libelle: libelle,
			// 		valeur: valeurSlide
			// 	});
			// 	btnPrev.querySelector('svg').setAttribute('data-ga', objSlide);
			// 	btnNext.querySelector('svg').setAttribute('data-ga', objSlide);
			// }
		}
	}

	// Encart de contextualisation
	let contextualisation = document.getElementById('contextualisation');
	if (contextualisation != null) {
		let contextualisationType = contextualisation.querySelectorAll('.lr__contextualisation a');
		if (contextualisationType != null) {
			for (var i = 0; i < contextualisationType.length; i++) {
				let categorie = 'Liste de résultats';
				let action = 'Click block de contextualisation';
				let libelle = contextualisationType[i].href;
				let valeur = '';
				let obj = JSON.stringify({
					categorie: categorie,
					action: action,
					libelle: libelle,
					valeur: valeur
				});
				contextualisationType[i].setAttribute('data-ga', obj);
			}
		}

	}

	// Ajout à la sélection
	let selection = document.querySelectorAll('.circuit--selection');
	if (selection.length > 0) {
		for (var i = 0; i < selection.length; i++) {
			let categorie = 'Circuit';
			let codeCircuit = selection[i].getAttribute('data-codeproduit');
			let action = 'Ajout à la sélection';
			let libelle = codeCircuit;
			let valeur = '';
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			selection[i].setAttribute('data-ga', obj);
		}
	}


	///
	/// Informations LR
	///

	// pages pays
	let linkPagePays = document.querySelector('.link--pays');
	if (linkPagePays != null) {
		let categorie = 'Guide';
		let action = 'Pages pays';
		let libelle = linkPagePays.href;
		let valeur = '';
		let obj = JSON.stringify({
			categorie: categorie,
			action: action,
			libelle: libelle,
			valeur: valeur
		});
		linkPagePays.setAttribute('data-ga', obj);
	}

	// vidéo
	let btnVideo = null;//document.getElementById('idVideoVimeo');
	if (btnVideo != null) {
		let link = btnVideo.querySelector('a');
		let categorie = 'Guide';
		let action = 'Vidéo';
		let libelle = link.href;
		let valeur = '';
		let obj = JSON.stringify({
			categorie: categorie,
			action: action,
			libelle: libelle,
			valeur: valeur
		});
		link.querySelector('img').setAttribute('data-ga', obj);
	}
	// linking
	let boxLinking = document.querySelectorAll('[data-boxlinking]');

	if (boxLinking.length === 1) {
		_tagLinking(boxLinking[0])
	} else if (boxLinking.length > 1) {
		boxLinking.forEach(el => _tagLinking(el))
	}

	function _tagLinking(el) {
		let link = el.querySelectorAll('a');
		let categorie = 'Guide';
		let action = 'Box de linking';
		let libelle = '';
		let valeur = el.dataset.boxlinking;

		for (var i = 0; i < link.length; i++) {
			if (link[i].closest('#menuNavigation')) {
				categorie = 'Menu mobile';
			} else {

			}
			libelle = link[i].href;
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			link[i].setAttribute('data-ga', obj);
		}
	}

	// Show info pratiques
	let arrow = document.querySelectorAll('.btn--toggle');
	if (arrow.length > 0) {
		for (var i = 0; i < arrow.length; i++) {
			let categorie = 'Guide';
			let action = 'Toggle';
			let libelle = 'show';
			let valeur = '';
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			arrow[i].setAttribute('data-ga', obj);
		}
	}

	///
	/// Divers
	///

	// Bouton plus de résultats
	let btnMoreresultat = document.querySelector('[data-js="getMoreResultat"]');
	if (btnMoreresultat != null) {
		let categorie = 'Liste de résultats';
		let action = 'show';
		let libelle = 'Voir plus de résultats';
		let valeur = '';
		let obj = JSON.stringify({
			categorie: categorie,
			action: action,
			libelle: libelle,
			valeur: valeur
		});
		btnMoreresultat.setAttribute('data-ga', obj);
	}

	// Avis
	let showAvis = document.querySelectorAll('[href="#avis"]');
	if (showAvis.length > 0) {
		for (var i = 0; i < showAvis.length; i++) {
			let categorie = 'Entête';
			if (showAvis[i].classList.contains('box__titre')) {
				categorie = 'Guide';
			}
			let action = 'Toggle';
			if (showAvis[i].classList.contains('box__titre')) {
				action = 'Voir plus d\'avis';
			}
			let libelle = 'avis';
			let valeur = '';
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			showAvis[i].setAttribute('data-ga', obj);

			if (showAvis[i].querySelector('span') !== null) {
				showAvis[i].querySelector('span').setAttribute('data-ga', obj);
			}
		}
	}

	// Mag
	let mag = document.getElementById('magazine');
	if (mag != null) {
		let categorie = 'Liste de résultats';

		let linkAllArticles = mag.querySelector('.link--all');
		if (linkAllArticles != null) {
			let action = 'Voir tous les articles';
			let libelle = linkAllArticles.querySelector('a').href;
			let valeur = '';
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			linkAllArticles.querySelector('a').setAttribute('data-ga', obj);
		}
		let linkArticlesMag = mag.querySelectorAll('[data-expand-link]');
		for (var i = 0; i < linkArticlesMag.length; i++) {
			let libelle = linkArticlesMag[i].href;
			let action = libelle === window.location.origin + '/informations/newsletter' ? 'Inscription newsletter' : 'Voir un article';
			let valeur = '';
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			linkArticlesMag[i].setAttribute('data-ga', obj);
		}
	}

	// suggestions
	let suggestions = document.getElementById('suggestions');
	if (suggestions != null) {
		let categorie = 'Liste de résultats';
		let linkSuggestionCircuits = suggestions.querySelectorAll('[data-expand-link]');
		for (var i = 0; i < linkSuggestionCircuits.length; i++) {
			let libelle = linkSuggestionCircuits[i].href;
			let action = 'Suggestions';
			let valeur = '';
			let obj = JSON.stringify({
				categorie: categorie,
				action: action,
				libelle: libelle,
				valeur: valeur
			});
			linkSuggestionCircuits[i].setAttribute('data-ga', obj);
		}
	}

}